export enum HeaderEnum {
  About = 'About',
  Account = 'Account',
  AccountManagement = 'Team',
  AdminConsole = 'Admin Console',
  Contact = 'Contact',
  Dashboard = 'Dashboard',
  HamburgerMenu = 'Menu',
  Home = 'Home',
  None = 'None',
  Pricing = 'Pricing',
  Profile = 'Profile',
  Services = 'Services',
  SignOut = 'Sign Out',
  TwoFactorAuthentication = 'Two-Factor Authentication',
  ThemeSelector = 'Theme Selector',
}

export default HeaderEnum;
